module.exports = __webpack_public_path__ + "img/illustration_reference_dialog.999dfedd.webp";